module.exports = __webpack_public_path__ + "img/mfd_in_2_pp1.230bcd1b.jpg";